import $http from "../../axios";
import { Notification } from "element-ui";


export async function fetchContacts({ commit, state, rootState }) {

    let params = { params: state.params_contacts};

    await $http
        .get("/api/terceros", params)
        .then(response => {
            commit("setContacts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchDeleteDocuments({ commit, state, rootState }) {
    state.loading.module = true
    await $http
        .post("/api/documentos/eliminar-documentos-admin", state.params)
        .then(response => {
            state.loading.module = false
            Notification.success({
                title: "Success!",
                message: response.data,
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });

        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.response.data,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/delete-documents/actions.js